import { Device } from '@capacitor/device';

export const getDeviceInfo = async () => {
  const info = await Device.getInfo();
  return info;
};

/* Creamos función para obtener lenguaje*/
export const getLanguageCode = async () => {
  const info = await Device.getLanguageCode();
  return info;
};
